var ol = require('openlayers');
var $ = require('jquery');

var OmsVectorSource = function(options){
    var that = this,
        _options = {};

    that._urlTemplate = options.urlTemplate
        ? options.urlTemplate + '&vector=1'
        : "";

    that._layers = options.layers
        ? options.layers
        : [];

    that._mapCode = options.mapCode
        ? options.mapCode
        : "";

    delete options['urlTemplate'];
    delete options['layers'];
    delete options['mapCode'];

    $.extend(true, _options, options);

    _options.format = new ol.format.MVT({
        // ol.Feature в общем случае не нужен и работает криво в новом OL (часть фич в тайлах теряется)
        // TODO разобраться, если заработает, то можно переписать интерактивность по аналогии с GeoJSON,
        // это возможно избавит от моргания слоя при перемещении карты, "зацепившись" за границу фич
        // featureClass: ol.Feature
    });

    _options.tileGrid = omjs.ol.tilegrid.createXYZ({maxZoom: 22});
    _options.tilePixelRatio = 16;

    _options.url = that._urlTemplate
        .replace('{map_code}', that._mapCode)
        .replace('{layers}', that._layers.join(','));
    _options.projection = 'EPSG:3857';

    ol.source.VectorTile.call(this, _options);

    that.loadingTiles = [];

    that.on('tileloadstart', function(e) {
        that.loadingTiles.push(e.tile);
    });

    that.on(['tileloadend', 'tileloaderror'], function(e) {
        var index = that.loadingTiles.indexOf(e.tile);
        if(~index){
            that.loadingTiles.splice(index, 1);
        }
    });
};

/**
 *
 * @type {{setLayers: Function}}
 */
OmsVectorSource.prototype = {};

ol.inherits(OmsVectorSource, ol.source.VectorTile);

OmsVectorSource.prototype.setActiveLayers = function(ids){
    var that = this,
        url;

    that._layers = ids;

    if (!that._layers.length) {
        that.clear();
        return;
    }

    url = that._urlTemplate
        .replace('{map_code}', that._mapCode)
        .replace('{layers}', that._layers.join(','));


    that.clear();
    that.setUrl(url);
    that.refresh();
};

OmsVectorSource.prototype.getActiveLayers = function() {
    return this._layers;
};

OmsVectorSource.prototype.cancelLoading = function() {
    var that = this;

    // that.loadingTiles.forEach(function(tile){
    //     tile.getImage().src = '';
    //     tile.changed();
    // });

    that.loadingTiles.length = 0;

    return that;
};

module.exports = OmsVectorSource;



//////////////////
// WEBPACK FOOTER
// ./src/View/OmsVectorSource.js
// module id = 51
// module chunks = 0